import { h } from 'preact'
import { selectedPalette } from '../../utils/plotColors.js'

/**
 * Reusable Color Palette Settings Component
 * Can be used in any settings panel
 */
export function ColorPaletteSettings() {
  const handlePaletteChange = (e) => {
    const newPalette = e.target.value
    selectedPalette.value = newPalette
    window.__COLOR_PALETTE__ = newPalette
    localStorage.setItem('batemo-color-palette', newPalette)
    
    // Log for debugging
    console.log('[ColorPalette] Changed to:', newPalette)
  }

  return (
    <div className="advanced-section">
      <div className="advanced-section-title">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="13.5" cy="6.5" r=".5"></circle>
          <circle cx="17.5" cy="10.5" r=".5"></circle>
          <circle cx="8.5" cy="7.5" r=".5"></circle>
          <circle cx="6.5" cy="12.5" r=".5"></circle>
          <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"></path>
        </svg>
        Color Palette
      </div>
      <div className="advanced-row">
        <label>Theme</label>
        <select 
          value={selectedPalette.value}
          onChange={handlePaletteChange}
          className="settings-select"
        >
          <option value="corporate">Corporate</option>
          <option value="vibrant">Vibrant</option>
          <option value="colorblind">Colorblind Safe</option>
          <option value="pastel">Pastel</option>
        </select>
      </div>
      <div className="advanced-help-text">
        {selectedPalette.value === 'corporate' && 'Batemo brand colors (Orange/Cyan)'}
        {selectedPalette.value === 'vibrant' && 'High contrast, bold colors'}
        {selectedPalette.value === 'colorblind' && 'Deuteranopia/Protanopia optimized'}
        {selectedPalette.value === 'pastel' && 'Soft colors, reduced eye strain'}
      </div>
    </div>
  )
}